module.exports = __webpack_public_path__ + "media/icons/tapicerka-materialowa-uactive@3x-51999575.svg";